import { render, staticRenderFns } from "./AuthBrandLayout.vue?vue&type=template&id=5e78c6d3&"
import script from "./AuthBrandLayout.vue?vue&type=script&lang=ts&"
export * from "./AuthBrandLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports